import React, { Component } from "react"
import ReactModal from "@components/global/ReactModal/ReactModal"
import Button from "@components/objects/Button/Button"
import saveStarPink from "@images/icons/saveStarPink.svg"
import saveStarWhite from "@images/icons/saveStarWhite.svg"
import SiteWrapper from "../../structure/SiteWrapper/SiteWrapper"
import SupplierList from "../../supplier/SupplierList/SupplierList"
import * as styles from "./SavedSuppliersModal.module.scss"

class SavedSuppliersModal extends Component {
  state = {
    modalIsOpen: false,
  }

  openModal = () => {
    this.setState({ modalIsOpen: true })
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  render() {
    const savedSuppliers =
      this.props.currentParty && this.props.currentParty.savedSuppliers
        ? this.props.currentParty.savedSuppliers
        : []
    return (
      <div>
        <ReactModal
          openModal={this.openModal}
          modalIsOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className={styles.SavedSuppliersModal}
          button={{
            className: `${savedSuppliers.length ? styles.active : ""} ${styles.sideTab}`,
            image: saveStarWhite,
            design: "solid",
            color: "pink",
            text: "(" + savedSuppliers.length + ")",
          }}
          modalLabel="Saved suppliers"
        >
          <section className={styles.modal}>
            <header>
              <h2>
                <img src={saveStarPink} alt="" />
                Saved suppliers <span>({savedSuppliers.length})</span>
              </h2>
            </header>
            <main>
              <SiteWrapper>
                <SupplierList className={styles.supplierList} suppliers={savedSuppliers} />
              </SiteWrapper>
            </main>
            <footer>
              <SiteWrapper>
                <div className={styles.buttons}>
                  {this.props.currentParty && this.props.currentParty.partyId ? (
                    <Button
                      text="Go to party"
                      link={"/party/" + this.props.currentParty.partyId}
                    />
                  ) : (
                    <Button text="Go to party dashboard" link={"/party-dashboard"} />
                  )}
                </div>
              </SiteWrapper>
            </footer>
          </section>
        </ReactModal>
      </div>
    )
  }
}

export default SavedSuppliersModal
